import { render, staticRenderFns } from "./policysummary.vue?vue&type=template&id=142b32b8&"
import script from "./policysummary.vue?vue&type=script&lang=js&"
export * from "./policysummary.vue?vue&type=script&lang=js&"
import style0 from "./policysummary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports